import React from "react"

export const  Data=[
    {
        icon1:<i class="fab fa-facebook-f"></i>,
        icon2:<i class="fab fa-twitter"></i>,
        icon3:<i class="fab fa-instagram"></i>,
        icon4:<i class="fab fa-linkedin-in"></i>,
        icon5:<i class="fab fa-google"></i>,
    }
]